import { Asset } from 'multichain-sdk'

export const currencyIndexAssets: Asset[] = [
  Asset.USD(),
  Asset.RUNE(),
  Asset.BTC(),
  Asset.ETH(),
  Asset.BNB(),
  Asset.LTC(),
]
